'use client'
import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import type { DialogAPI } from '@fukku/dialog'
import srOnly from '@fukku/styles/src/srOnly.module.css'
import { IconPlusSmall } from 'icons/components/IconPlusSmall'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useAddSelectedSize } from 'product-card/hooks/useAddSelectedSize/useAddSelectedSize'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { appsAddToBag } from 'product-card/utils/appsAddToBag/appsAddToBag'
import { SizesBottomSheet } from 'product-components/components/SizeSelector/SizesBottomSheet/SizesBottomSheet'
import { useCallback, useRef } from 'react'
import type { PlpDomainData } from 'types/masterData/domainData/domainData'
import styles from './SizeSheetIcon.module.scss'

export const SizeSheetIcon = () => {
	const { isApp, custom } = useMasterData()
	const sizeSheetRef = useRef<DialogAPI>(null)
	const { t } = useLabels()

	const { product, productId, selectedColorId, lookId, location } =
		useProductCard()

	const onOpen = useCallback(() => {
		if (isApp) {
			appsAddToBag(productId, selectedColorId, lookId, custom as PlpDomainData)
		} else {
			sizeSheetRef.current?.show()
		}
	}, [isApp, productId, selectedColorId, lookId, custom])

	const { onAdd } = useAddSelectedSize({
		opened: sizeSheetRef.current?.open ?? false,
	})

	return (
		<>
			<ButtonIconTransparent
				className={styles.button}
				onClick={onOpen}
				data-testid='productCard.sizeSheetIconButton'
			>
				<IconPlusSmall />
				<span className={srOnly.className}>
					{t('productCard.showSizes.button')}
				</span>
			</ButtonIconTransparent>
			<SizesBottomSheet
				ref={sizeSheetRef}
				product={product}
				productId={productId}
				selectedColorId={selectedColorId}
				onSelectedSize={onAdd}
				location={location}
			/>
		</>
	)
}
